module.exports = __webpack_public_path__ + "public/images/partners/sup-12.7d6e9bde217bebcc95d8f7bae61c9d39.svg";